<script>

    import { onMount } from 'svelte';
    import { localStorageQuestionnaireAnswers, getLocalStorageItem, getData } from '../../utility.js';
    import ProgressBar from "./ProgressBar.svelte";

    let progress = 0;
    let totalQuestionCount = 0;
    let currentQuestionCount = 0;
    let scale = 7; // horse size = png size / scale
    let calculatedProgress = false;

    function sleep (ms) {
        return new Promise(r => setTimeout(r, ms))
    }

    function getCurrentQuestionCount(questionnaireAnswers) {
        currentQuestionCount = 0;
        for (const key in questionnaireAnswers) {
            const obj = questionnaireAnswers[key];
            currentQuestionCount += Object.keys(obj).length;
        }
        return currentQuestionCount;
    }

    function initProgressBar() {
        let answer = getLocalStorageItem('questionnaireAnswers') || {}
        currentQuestionCount = getCurrentQuestionCount(answer);

        progress = (currentQuestionCount / totalQuestionCount) * 100;
        calculatedProgress = true;
    }

    async function updateProgressBar(questionnaireAnswers) {
        if (!Number.isFinite(totalQuestionCount)) {
            return;
        }
        currentQuestionCount = getCurrentQuestionCount(questionnaireAnswers);
        let new_progress = (currentQuestionCount / totalQuestionCount) * 100;
        if (new_progress < 0 || new_progress > 100) {
            return
        }
        while (new_progress >= 0 && new_progress <= 100 && progress >= 0 && progress <= 100 && new_progress > progress) {
            progress += 0.5;
            await sleep(40);
        }
    }

    localStorageQuestionnaireAnswers.subscribe( questionnaireAnswers => {
        updateProgressBar(questionnaireAnswers);
    });

    onMount(async () => {
        const data = await getData('get-question-count/');
        totalQuestionCount = await data.question_count;
        initProgressBar()
        await updateProgressBar(getLocalStorageItem('questionnaireAnswers') || {});
    });
</script>

<ProgressBar
        progress="{progress}"
        scale="{scale}"
        calculatedProgress="{calculatedProgress}"
        showHorse="{true}"
        showPercentage="{true}"
/>
